import { useCallback, useState } from 'react'

import { Button } from '@/components/ui/button.tsx'
import { Dialog } from '@/components/ui/dialog.tsx'
import type { DialogProps } from '@/dialogs/types'

interface Props extends DialogProps {
  onSubmit: () => Promise<unknown>
}

export const FunnelTrackingDeleteDialog = ({
  isOpen,
  onClose,
  onSubmit,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  const handleSubmit = useCallback(async () => {
    setIsLoading(true)
    try {
      await onSubmit()

      onClose()
    } catch (error) {
      /* empty */
    } finally {
      setIsLoading(false)
    }
  }, [onClose, onSubmit])

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
    >
      <Dialog.Header>
        <Dialog.Title>Are you sure?</Dialog.Title>
        <Dialog.Description className="text-center">
          This action cannot be undone and will permanently remove.
        </Dialog.Description>
      </Dialog.Header>

      <Dialog.ClosableFooter
        onClose={onClose}
        className="mt-6"
      >
        <Button
          variant="destructive"
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          Remove
        </Button>
      </Dialog.ClosableFooter>
    </Dialog>
  )
}
